module.exports = {
  siteTitle: "Preferred Cabling Systems | Fiber Optics & Low Voltage", // Site title.
  siteTitleAlt: "PCS", // Alternative site title for SEO.
  siteLogo: "../assets/logo.svg", // Logo used for SEO and manifest.
  siteUrl: "https://preferredcabling.com", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: "Low Voltage Contractors, BDA + DAS Experts, Fiber Optic Installers, Access Control, CCTV IP Camera Installers, Data Network Cabling.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml",
  siteFBAppID: "", // FB Application ID for using app insights
  googleTagManagerID: "", // GTM tracking ID.
  copyright: "Copyright © Preferred Cabling Systems 2018. All Rights Reserved.", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#DC143C", // Used for setting manifest and progress theme colors.
  backgroundColor: "#ffffff" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./src/meta/config.js